import React from "react";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";
import RootGoogleLoginCallback from "container/googleLoginCallback/RootGoogleLoginCallback";

// 이거 비회원 로그인 막어 말어?
// 미완성
function GoogleLoginCallbackPage(props) {
  return (
    <AppUpdateCheckpoint>
      <RootGoogleLoginCallback />
    </AppUpdateCheckpoint>
  );
}

export default GoogleLoginCallbackPage;
